<template>
  <div class="h-100">
    <div class="dp02 py-3 mt-3">
      <div class="col-lg-12">
        <b-button type="submit"
                  class="myButton"
                  @click="$router.go(-1)"
                  style="float:left">
          {{ $t('common.Back') }}
        </b-button>

        <b-button type="submit"
                  class="myButton"
                  @click="$router.push({ name: isInDoctorSection ? 'admin.products/doctorsection.edit' : 'admin.products.edit', params: { id:id } });"
                  style="float:right"
                  v-if="!isArchived">
          {{ $t('common.Edit') }}
        </b-button>
      </div>
      <div class="text-center row col-lg-12 mb-3">
        <div class="col-4 offset-4">
          <h2>{{ $t('entities.Product.Singular') }} {{ customerName }}</h2>
        </div>
      </div>
      <div class="col-12"
           v-if="isArchived">
        <v-alert
          outlined
          type="warning"
          border="top">
          Prohlížíte archivované výsledky
        </v-alert>
      </div>
      <div class="w-100"
           v-if="!ready">
        <div class="text-center my-2 w-100">
          <p>
            <b-spinner class="align-middle" />
            <strong class="ml-1">{{ $t("DataTable.Loading") }}...</strong>
          </p>
          <p>
            Operace může trvat několik desítek sekund
          </p>
        </div>
      </div>
      <div class="col-12 px-4"
           v-else>
        <div class="row">
          <div class="col-12 dp02 text-center">
            <div class="row">
              <div class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="gender">{{ $t('fields.status') }}:</label>
                </div>
                <div class="col-lg-9">
                  <ProductStatusInput :editable="false"
                                      v-model="status" />
                </div>
              </div>
              <div class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.generatedAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="generatedAtFormatted" />
                </div>
              </div>
              <div class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.doctor') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="doctor" />
                </div>
              </div>
              <div v-if="lastChangeAt !== null"
                   class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.lastChangeAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="lastChangeAtFormatted" />
                </div>
              </div>
              <div v-if="doctorsIntroLastChange !== null"
                   class="row my-3 col-lg-4 text-left">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.doctorsIntroLastChange') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="doctorsIntroLastChangeFormatted" />
                </div>
              </div>
              <div class="row my-3 col-lg-4 text-left"
                   v-if="status === 3">
                <div class="col-lg-3">
                  <label for="updatedAt">{{ $t('fields.publishedAt') }}:</label>
                </div>
                <div class="col-lg-9">
                  <b-form-input
                    class="myInput"
                    :disabled="true"
                    v-model="publishedAtFormatted" />
                </div>
              </div>
            </div>
            <div class="row my-3 col-lg-4 text-left">
              <div class="col-lg-3">
                <label for="productType">{{ $t('fields.productTypeId') }}:</label>
              </div>
              <div class="col-lg-9">
                <b-form-input
                  class="myInput"
                  :disabled="true"
                  v-model="productType" />
              </div>
            </div>
            <div v-if="doctorIntroReproductiveGeneticsEnabled" class="row col-lg-4 my-3 text-left">
              <div class="col-lg-3">
                <label for="partner">{{ $t('fields.assignedCustomer') }}:</label>
              </div>
              <div class="col-lg-9">
                <b-button variant="outline-info"
                          @click="$router.push({ name: 'admin.customers.edit', params: { id:partnerId } });">
                  {{ partner }}
                </b-button>
              </div>
            </div>
          </div>

          <div class="col-6 mt-2 dp02 text-center">
            <b-card no-body>
              <b-tabs card justified>
                <b-tab>
                  <template #title>
                    <h3>
                      {{ $t('EditProduct.DoctorIntro') }}
                    </h3>
                  </template>
                  <ckeditor v-model="doctorIntro"
                            :editor="editor"
                            @ready="onReady"
                            :disabled="true"
                            style="height:80vh"
                            :config="editorConfig" />
                </b-tab>
                <b-tab v-if="doctorIntroReproductiveGeneticsEnabled">
                  <template #title>
                    <h3>
                      {{ $t('EditProduct.ReproductiveGenetics') }}
                    </h3>
                  </template>
                  <ckeditor v-model="doctorIntroReproductiveGenetics"
                            :editor="editor"
                            @ready="onReady"
                            :disabled="true"
                            style="height:80vh"
                            :config="editorConfig" />
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
          <div class="col-6 mt-2 dp02 result-edit">
            <h3 class="text-center">
              {{ $t('entities.Product.Singular') }}
            </h3>
            <ProductDisplay :product="product"
                            :editing="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import ProductDisplay from '@components/admin/products/ProductDisplay';
import ProductStatusInput from '@components/input/ProductStatusInput';
import DecoupledEditor from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadAdapterPlugin from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import FontFamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontSizePlugin from '@ckeditor/ckeditor5-font/src/fontsize';
import FontColorPlugin from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontBackgroundColorPlugin from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline';
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlockPlugin from '@ckeditor/ckeditor5-indent/src/indentblock';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import BlockQuotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyImagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import ImageCaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import TablePlugin from '@ckeditor/ckeditor5-table/src/table';
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import MediaEmbedPlugin from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HorizontalLinePlugin from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';

export default {
  name: 'EditSample',
  components: {
    ProductStatusInput,
    ProductDisplay
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          AutoformatPlugin,
          HeadingPlugin,
          FontFamilyPlugin,
          FontSizePlugin,
          FontColorPlugin,
          FontBackgroundColorPlugin,
          BoldPlugin,
          ItalicPlugin,
          UnderlinePlugin,
          StrikethroughPlugin,
          AlignmentPlugin,
          ListPlugin,
          IndentPlugin,
          IndentBlockPlugin,
          LinkPlugin,
          BlockQuotePlugin,
          ImagePlugin,
          ImageCaptionPlugin,
          ImageStylePlugin,
          ImageToolbarPlugin,
          EasyImagePlugin,
          ImageUploadPlugin,
          TablePlugin,
          TableToolbarPlugin,
          MediaEmbedPlugin,
          ParagraphPlugin,
          UploadAdapterPlugin,
          HorizontalLinePlugin
        ],
        toolbar: [
          'heading',
          '|',
          'fontFamily',
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'outdent',
          'indent',
          '|',
          'link',
          'blockQuote',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          '|',
          'undo',
          'redo',
          '|',
          'horizontalLine'
        ],
        fontFamily: {
          supportAllValues: true
        },
        fontSize: {
          options: [
            'tiny',
            'small',
            'default',
            'big',
            'huge'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    status: {
      get() {
        return this.$store.state.editProduct.status;
      },
      set(val) {
        this.setStatus(val);
      }
    },
    doctorIntro: {
      get() {
        return this.$store.state.editProduct.doctorIntro;
      },
      set(val) {
        this.setDoctorIntro(val);
      }
    },
    doctorIntroReproductiveGenetics: {
      get() {
        return this.$store.state.editProduct.doctorIntroReproductiveGenetics;
      },
      set(val) {
        this.setDoctorIntroReproductiveGenetics(val);
      }
    },
    isInDoctorSection: {
      get() {
        return this.$store.state.editProduct.isInDoctorSection;
      }
    },
    isArchived: {
      get() {
        return this.$store.state.editProduct.isArchived;
      }
    },
    generatedAtFormatted() {
      return this.$moment(this.generatedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    publishedAtFormatted() {
      return this.$moment(this.publishedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    lastChangeAtFormatted() {
      return this.$moment(this.lastChangeAt).format('DD.MM.YYYY HH:mm:ss');
    },
    doctorsIntroLastChangeFormatted() {
      return this.$moment(this.doctorsIntroLastChange).format('DD.MM.YYYY HH:mm:ss');
    },
    ...mapState('editProduct', [
      'customerName',
      'product',
      'publishedAt',
      'generatedAt',
      'ready',
      'lastChangeAt',
      'doctorsIntroLastChange',
      'doctor',
      'productType',
      'doctorIntroReproductiveGeneticsEnabled',
      'partner',
      'partnerId',
    ]),
  },
  mounted() {
    this.resetContext();
    this.setProductId(this.id);
    this.fetchProduct()
      .then((result) => {
        if (!result) {
          this.$root.$bvToast.toast(this.$t('FetchProduct.FailToast.Body'), {
            title: this.$t('FetchProduct.FailToast.Title'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
        }
      });
  },
  methods: {
    ...mapMutations({
      setProductId: 'editProduct/setProductId',
      setStatus: 'editProduct/setStatus',
      setDoctorIntro: 'editProduct/setDoctorIntro'
    }),
    ...mapActions({
      resetContext: 'editProduct/resetContext',
      fetchProduct: 'editProduct/fetchProduct'
    }),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    async submit(status) {
      this.setStatus(status);
      this.editProduct().then(() => {
        this.$root.$bvToast.toast(this.$t('EditSample.SuccessToast.Body'), {
          title: this.$t('EditSample.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.$root.$router.replace({ name: 'admin.samples.view' });
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('EditSample.FailureToast.Body'), {
          title: this.$t('EditSample.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
